import { createWidgetRouter } from "@blockdaemon/widget-host";

import { routeTree } from "./routeTree.gen";

export function createEarnRouter() {
  return createWidgetRouter(routeTree);
}
